module.exports = __webpack_public_path__ + "static/media/QR.57a721bc.webp";